import eventsMap from "~/analytics";

const dataLayer = window.dataLayer || [];

const analyticsMiddleware = () => (next) => (action) => {
  if (action.type in eventsMap) {
    dataLayer.push(eventsMap[action.type](action))
  }
  return next(action);
};

export default analyticsMiddleware